import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Users, Leaf, MapPin, ChatCircleDots, Scales } from "@phosphor-icons/react";

export default function GovDashboard() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/gov/summary").then(r => setS(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);

  if (!s) return <div className="text-sm text-[#8A8780]">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="gov-dashboard">
      <div>
        <h1 className="font-heading text-3xl">Public Health Dashboard</h1>
        <p className="text-sm text-[#5C5A55] mt-1">
          Read-only jurisdiction overview · Last 30 days
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="gov-kpis">
        <Card icon={Users} title="Active Citizens" value={s.customers.active} sub={`${s.customers.pending} pending`}/>
        <Card icon={Leaf} title="Waste Collected" value={`${s.waste_30d.kg} kg`} sub={`${s.waste_30d.bags} bags`}/>
        <Card icon={Scales} title="CO₂ Reduced" value={`${s.waste_30d.co2_kg} kg`} sub="last 30 days"/>
        <Card icon={ChatCircleDots} title="Open Complaints" value={s.complaints_open} sub="action needed"/>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card icon={MapPin} title="Health Zones" value={s.zones} sub="in jurisdiction"/>
        <Card icon={MapPin} title="Wards" value={s.wards} sub="in jurisdiction"/>
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md p-5 text-xs text-[#5C5A55]">
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A8780] mb-1">Your jurisdiction</div>
        <div className="font-mono">
          State: {s.jurisdiction.state_id || "ALL"} · District: {s.jurisdiction.district_id || "ALL"} · LSGD: {s.jurisdiction.lsgd_id || "ALL"}
        </div>
      </div>
    </div>
  );
}

const Card = ({ icon: Icon, title, value, sub }) => (
  <div className="bg-white border border-[#E5E2D9] rounded-md p-5">
    <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#8A8780]">
      <Icon size={12}/>{title}
    </div>
    <div className="font-heading text-3xl mt-2">{value}</div>
    <div className="text-xs text-[#5C5A55] mt-1">{sub}</div>
  </div>
);
